export default __webpack_public_path__ + "static/testimonial-bg@2x-2a611b5c54298eee3cda96161f93a02d.png";